<template>
  <div class="container-fluid-banner-publicidad p-0 p-md-3">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-12 p-0 p-md-1 text-center">
					
          <a href=" https://www.mcdonalds.com/us/es-us/mobile-order-and-pay.html " target="_blank"><img class="publiciti" src="/especiales/noticias/2022/jaimejarrin/images/banner728x90.jpg" alt="Jaime Jarrin"/></a>
        </div>
      </div>
    </div>       
  </div>
</template>

<script>
	export default {
		name: 'PubliciPage',
		props: {
		msg: String
		}
	}
</script>